import { ConcernElementsInformationOwner } from '@/libs/product'

const REQUEST_HANDLING_WORKFLOW_SCHEMA_VERSION = 1

const RequestHandlingStrategy = Object.freeze({
    ANSWER_REQUEST_DIRECTLY: 'answer-request-directly',
    FORWARD_TO_PRODUCT_SUPPLIER: 'forward-to-product-supplier',
    COLLECT_FROM_COMPONENT_SUPPLIERS: 'collect-from-component-suppliers',
})

const REQUEST_HANDLING_STRATEGIES = Object.freeze(Object.values(RequestHandlingStrategy))

const requestHandlingStrategiesForMode = (context = {}, settings = {}) => {
    if (context.mode !== 'bulk' || !Array.isArray(settings.bulkAllowedStrategies)) {
        return REQUEST_HANDLING_STRATEGIES
    }

    return settings.bulkAllowedStrategies.filter(strategy => (
        REQUEST_HANDLING_STRATEGIES.includes(strategy)
    ))
}

const isRequestHandlingStrategyAllowed = (strategy, context = {}, settings = {}) => (
    requestHandlingStrategiesForMode(context, settings).includes(strategy)
)

const requestDomainStateForStrategy = strategy => {
    if (strategy === RequestHandlingStrategy.ANSWER_REQUEST_DIRECTLY) {
        return {
            informationOwner: ConcernElementsInformationOwner.WE,
            isComplexProduct: false,
        }
    }

    if (strategy === RequestHandlingStrategy.FORWARD_TO_PRODUCT_SUPPLIER) {
        return {
            informationOwner: ConcernElementsInformationOwner.SUPPLIER,
            isComplexProduct: false,
        }
    }

    if (strategy === RequestHandlingStrategy.COLLECT_FROM_COMPONENT_SUPPLIERS) {
        return {
            informationOwner: ConcernElementsInformationOwner.WE_PARTIALLY,
            isComplexProduct: true,
        }
    }

    throw new Error(`Unsupported request handling strategy "${strategy}"`)
}

const createRequestHandlingWorkflowState = strategy => ({
    schemaVersion: REQUEST_HANDLING_WORKFLOW_SCHEMA_VERSION,
    requestHandling: { strategy },
})

export {
    REQUEST_HANDLING_STRATEGIES,
    REQUEST_HANDLING_WORKFLOW_SCHEMA_VERSION,
    RequestHandlingStrategy,
    createRequestHandlingWorkflowState,
    isRequestHandlingStrategyAllowed,
    requestDomainStateForStrategy,
    requestHandlingStrategiesForMode,
}
